<div class="voucher-table-container">
  
  <div class="create-voucher-container" (click)="opendialog(0, 'none')">
    <button class="create-voucher-btn">
      <mat-icon>add</mat-icon> Create a new voucher
    </button>
  </div>  
  <div class="client_business_search">
    <mat-form-field class="client_business_form_fields" appearance="outline">
      <input matInput type="text" placeholder="Search"/>
      <mat-icon matSuffix style="color: black;">search</mat-icon>
    </mat-form-field>
  </div>
<div *ngIf="vouchers.length == 0" style="text-align: center;">
  <img src="assets/manager/voucher.png" class="voucher_image">
  <div style="font-size: 35px;font-family: var(--font);line-height: 1;color: grey;padding: 20px 0px;">No Voucher Available</div>
</div>
<div *ngIf="vouchers.length > 0" >
  <div class="voucher-table">
    <table >
      <thead>
        <tr>
          <th>Voucher Code</th>
          <th>Voucher Value</th>
          <th>Created On</th>
          <th>Used On</th>
          <th>User Name</th>
          <th>Business Name</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let voucher of vouchers">
          <td>{{ voucher.VoucherCode }}</td>
          <td>{{ voucher.VoucherValue }}</td>
          <td>{{ voucher.CreatedOn | date }}</td>
          <td>{{ voucher.UsedOn ? (voucher.UsedOn | date) : 'Not Used' }}</td>
          <td>{{ voucher.UserName }}</td>
          <td>{{ voucher.BusinessInfoName }}</td>
          <td  [class.active]="voucher.VoucherStatus === 'Active'" [class.inactive]="voucher.VoucherStatus !== 'Active'" style="font-weight: 400;">
            {{ voucher.VoucherStatus }}
          </td>
          <td>
            <button class="edit-btn" (click)="opendialog(voucher.VoucherId,voucher.VoucherCode)"><mat-icon class="material-symbols-outlined">edit</mat-icon></button>
            <button class="delete-btn" (click)="deleteVoucher(voucher.VoucherId)"><mat-icon class="material-symbols-outlined">delete</mat-icon ></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
</div>
  
</div>
